import React from "react";
import { AlertTriangle } from "lucide-react";

export function shelfLabel(l) {
  if (l.shelf_pct === null || l.shelf_pct === undefined) return "—";
  return l.expired ? "SÜRESİ DOLDU" : `%${l.shelf_pct}`;
}

export function LotAlerts({ alerts }) {
  return (
    <div className="mb-4 rounded-xl border border-amber-200 bg-amber-50/60" data-testid="lot-alerts">
      <div className="px-4 py-2 text-xs font-semibold uppercase tracking-wider text-amber-800 border-b border-amber-200">
        Raf Ömrü Uyarıları (%50 ve üzeri) — {alerts.length}
      </div>
      <div className="max-h-40 overflow-y-auto px-4 py-2 space-y-1.5" data-testid="lot-alerts-list">
        {!alerts.length && <div className="text-xs text-slate-500" data-testid="lot-alerts-empty">Uyarı gerektiren lot yok.</div>}
        {alerts.map((a) => (
          <div key={a.id} className={`flex items-start gap-2 text-sm ${a.expired ? "text-rose-700" : "text-amber-900"}`} data-testid={`lot-alert-${a.id}`}>
            <AlertTriangle size={14} className="mt-0.5 shrink-0" />
            <div>
              <b>{a.product_name}</b> / {a.lot_code} —{" "}
              {a.expired
                ? <span className="font-bold" data-testid={`lot-alert-expired-${a.id}`}>SÜRESİ DOLDU</span>
                : <span>Raf ömrünün <b data-testid={`lot-alert-pct-${a.id}`}>%{a.shelf_pct}</b>'i tamamlandı.</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
